import StoryWithImage from "./StoryWithImage";
import TitleAuthorCard from "./TitleAuthorCard";
import { SectionImageTitleSkeleton } from "../skeleton/DesktopSkelton";
import { Link } from "@quintype/components";
import React from "react";

export default function SectionImageTitle({ section, title, slug }) {
  if (!section || section.length === 0) {
    return <SectionImageTitleSkeleton />;
  }
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-start">
        <Link href={`/section/${slug}`}>
          <h2 className="mb-4 text-2xl font-medium text-[#ca4242]">{title}</h2>
        </Link>
        {/* <div className="text-primary">
          <LeftArrow />
        </div> */}
      </div>
      {/* <hr className="mb-4 h-[3px] w-[15%] border-none bg-primary" /> */}

      <div>
        {section.map((item, i) => {
          if (i === 0) {
            return <StoryWithImage key={item.id} story={item} />;
          } else {
            return <TitleAuthorCard key={item.id} story={item} />;
          }
        })}
      </div>
    </div>
  );
}
